import { Component,Input, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SchoolDetails } from "../../scp/schools/models";
import { PreferenceSet, PreferenceInstrumentClass } from "../../scp/preferences/models";
import { SupplyItem } from "../../scp/preferences/models";
import * as fromServices from "../../scp/scp-common/services"
import * as fromStore from '../../scp/preferences/store';
import { Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { toArray } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'opus-reports-school-preferences-row',
  templateUrl: './reports-school-preferences-row.component.html'
})

export class ReportsSchoolPreferencesRowComponent implements OnInit, OnDestroy {
  private _alive = true;
  @Input() schoolId: number;
  @Input() vm$: Observable<PreferenceSet>;
  vm: PreferenceSet;
  //@Input() preferences: PreferenceInstrumentClass[];
  //@Input() supplyItems: SupplyItem[];
  pref: PreferenceInstrumentClass[];
  supplyItems: SupplyItem[];

  constructor(private schoolService: fromServices.SchoolService,
    private prefsService: fromServices.PrefsService,
    private store: Store<fromStore.PrefsState>,
    private route: ActivatedRoute) {

  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this._alive = false;
  }

  get instSupplyItems() {
    return this.supplyItems;
  }
}
